import { render, staticRenderFns } from "./ProjectDetailLayout.vue?vue&type=template&id=6715adc6&scoped=true&"
import script from "./ProjectDetailLayout.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailLayout.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailLayout.vue?vue&type=style&index=0&id=6715adc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6715adc6",
  null
  
)

export default component.exports